const appKey = process.env.GATSBY_APP
if (!appKey) {
  throw new Error("appKey 不能为空")
}

const title = "BOOOMLab暴造实验室"
const desc = "欢迎你的参与～"

const cdnUrl = "https://site.gcores.com"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
  data: {
    2023: {
      oneLink: "https://www.gcores.com/topics/522",
      teamLink: "https://www.gcores.com/topics/521",
      offlineEnroll:
        "https://shimo.im/tables/e1AzdzxParcK2OqW?table=2jAg33DA6wr&view=Jfzv77yghv5#/ ",
      submitGameLink: "https://www.gcores.com/articles/166349",
      enrollLink: "https://shimo.im/forms/tlEoh0V7CEwNX9Hr/fill",
      preGamesLink: "https://site.gcores.com/booom2022horror/games/",
      feedbackLink: "https://www.gcores.com/topics/421",
      kaituoLink: "https://site.gcores.com/booom2023/kaituoxin/",
      publishingLink: "https://site.gcores.com/publishing/",
      reviewLink:
        "https://www.taptap.cn/video/1952058/embed?thumb=https%3A%2F%2Fimg2.tapimg.com%2Fbbcode%2Fimages%2F016cab6cae67c0c4e6da36028db3cced.png",
    },
    "2024_board_game_unplug": {
      enrollLink: "https://shimo.im/forms/m4kMMjEwjKIVVxkD/fill",
      kaituoLink: "https://www.coreblazer.com/",
    },
  },
}
